import {useCallback, useEffect, useRef, useState} from 'react';
import {CarouselScrollState, NOT_SCROLLABLE, getCarouselScrollState} from './Carousel.utils';

export const useCarouselScrollState = () => {
  const scroller = useRef<HTMLUListElement>(null);
  const [scrollState, setScrollState] = useState<CarouselScrollState>(NOT_SCROLLABLE);

  const syncScrollState = useCallback(() => setScrollState(getCarouselScrollState(scroller.current)), []);

  useEffect(() => {
    syncScrollState();

    const observer = new ResizeObserver(syncScrollState);
    observer.observe(scroller.current);

    return () => observer.disconnect();
  }, [syncScrollState]);

  return {scroller, ...scrollState, syncScrollState};
};
